import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectQuizQuestions, selectTotal, selectPage, selectLimit } from '../selectors/quiz-questions.selector';
import { quizQuestionsActions } from '../actions/quiz-questions.actions';
import { PaginationParams } from '../types';

@Injectable({
    providedIn: 'root',
})
export class QuizQuestionsFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((loaded) => loaded !== null));
    readonly loading$ = this.store.select(selectLoading);
    readonly quizQuestions$ = this.store.select(selectQuizQuestions);
    readonly total$ = this.store.select(selectTotal);
    readonly page$ = this.store.select(selectPage);
    readonly limit$ = this.store.select(selectLimit);

    readonly quizQuestions = this.store.selectSignal(selectQuizQuestions);
    readonly total = this.store.selectSignal(selectTotal);
    readonly loading = this.store.selectSignal(selectLoading);

    getQuizQuestions(value: PaginationParams): void {
        this.store.dispatch(quizQuestionsActions.getQuizQuestions({ value }));
    }

    clear(): void {
        this.store.dispatch(quizQuestionsActions.clear());
    }
}
